module.exports = __webpack_public_path__ + "img/american-bittern.af34d61d.jpg";